/**
 * @param {string} givenPath
 * @param {!Object} obj
 * @returns {any|undefined}
 */
const deepFindInObject = (givenPath, obj) => {
	if (!givenPath.includes('.')) {
		return obj?.[givenPath];
	}
	
	const paths = givenPath.split('.');
	
	let current = obj;
	
	for (const path of paths) {
		current = current?.[path];
	}
	
	return current;
};

module.exports = deepFindInObject;